/** De fire områdene i teamhelse-målingen, med oversettelser under teamHealthCategories */
export type HealthCategoryKey =
  | 'recognitionAndAppreciation'
  | 'inclusionAndRespect'
  | 'trustAndSupport'
  | 'safetyAndOpenness';

/** Backend sender kategorinavnet som tekst, på norsk eller engelsk */
export const getHealthCategoryKey = (category: string): HealthCategoryKey | null => {
  if (!category) return null;
  const lowerCategory = category.toLowerCase();

  if (lowerCategory.includes('anerkjennelse') || lowerCategory.includes('verdsetting') ||
      lowerCategory.includes('recognition') || lowerCategory.includes('appreciation')) {
    return 'recognitionAndAppreciation';
  }
  if (lowerCategory.includes('inkludering') || lowerCategory.includes('respekt') ||
      lowerCategory.includes('inclusion') || lowerCategory.includes('respect')) {
    return 'inclusionAndRespect';
  }
  if (lowerCategory.includes('tillit') || lowerCategory.includes('støtte') ||
      lowerCategory.includes('trust') || lowerCategory.includes('support')) {
    return 'trustAndSupport';
  }
  if (lowerCategory.includes('trygghet') || lowerCategory.includes('åpenhet') ||
      lowerCategory.includes('safety') || lowerCategory.includes('openness')) {
    return 'safetyAndOpenness';
  }
  return null;
};
